import { getPlayedBoardNumbers } from '../services/state';

const TUTORIAL_COMPLETED_KEY = 'combos_tutorial_completed';

// Anyone who already has a completed board predates this feature and shouldn't be
// forced through a tutorial retroactively - having played anything at all counts
// as having already "graduated," even if the flag itself was never explicitly set.
export const hasTutorialBeenCompleted = () => {
    try {
        if (localStorage.getItem(TUTORIAL_COMPLETED_KEY) === 'true') return true;
    } catch (e) { /* ignore unavailable local storage */ }

    return getPlayedBoardNumbers().length > 0;
};

export const markTutorialCompleted = () => {
    try {
        localStorage.setItem(TUTORIAL_COMPLETED_KEY, 'true');
    } catch (e) { /* ignore unavailable local storage */ }
};
